import React, { useState } from 'react';
import {
  Badge,
  Button,
  Icon,
  InputAdornment,
  FormHelperText,
  MenuItem,
  TextField,
  Toolbar,
  Tooltip,
  Typography
} from '@material-ui/core';
import { useStyles } from './styles';


const CustomTableToolbar = ({
  onSearch,
  setOpenFilter,
  filterConditions
}) => {
  const classes = useStyles();
  const [searchValue, setSearchValue] = useState('');
  const [searchField, setSearchField] = useState('increment_id');
  const selectedConditions = Object.values(filterConditions)
    .filter((condition: {value: string}) => !!condition?.value);

  return (
    <Toolbar className="w-full relative" disableGutters>
      <div className="flex-column w-full">
        <div className="flex items-center w-full justify-between">
          <div className="w-full">
            <TextField
              variant="outlined"
              className={`w-full max-w-300 text-primary ${classes.bgBlue} ${classes.customSearch}`}
              name="search-subscription-value"
              placeholder="Search"
              value={searchValue}
              onChange={(event) => setSearchValue(event.target.value)}
              onKeyDown={(event) => {
                if (event.key === 'Enter') {
                  event.preventDefault();
                  onSearch(searchValue, searchField);
                }
              }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    {!searchValue.length ?
                      <Icon color="primary">search</Icon>
                      :
                      <Icon
                        color="primary"
                        className="cursor-pointer"
                        onClick={() => {
                          setSearchValue(() => '');
                          onSearch('', 'increment_id');
                        }}
                      >
                        close
                      </Icon>
                    }
                  </InputAdornment>
                ),
              }}
            />
            <TextField
              select
              variant="outlined"
              className={`w-full max-w-200 mr-3 text-primary ${classes.bgBlue} ${classes.customSearchField}`}
              name="search-subscription-field"
              value={searchField}
              onChange={(event) => {
                setSearchField(event.target.value);

                if (searchValue) {
                  onSearch(searchValue, event.target.value);
                }
              }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">by</InputAdornment>
                )
              }}
            >
              <MenuItem value="increment_id">ID</MenuItem>
              <MenuItem value="description">Description</MenuItem>
            </TextField>
            <Button
              color="primary"
              variant="contained"
              className="mr-3 px-3 min-w-100 min-h-40"
              onClick={() => onSearch(searchValue, searchField)}
            >
              <Icon className="mr-2">search</Icon>
              <span className="uppercase">Search</span>
            </Button>
          </div>
          <Badge
            badgeContent={selectedConditions.length}
            color="primary"
            overlap="rectangular"
          >
            <Tooltip title="Filter by">
              <Button
                variant="outlined"
                color="primary"
                className={classes.filterBtn}
                onClick={() => setOpenFilter(true)}
              >
                <Icon className="mr-2 text-primary">
                  filter_list
                </Icon>
                <span className="text-brand">Filter By</span>
              </Button>
            </Tooltip>
          </Badge>
        </div>
        {!!searchValue.length &&
        <FormHelperText className={classes.helperText}>
          <Typography variant="caption">
            {'Press \'Enter\' to search'}
          </Typography>
        </FormHelperText>
        }
      </div>
    </Toolbar>
  );
};

export default CustomTableToolbar;
